import { Link } from "react-router-dom";
import { formatUsd } from "../lib/format";
import { MarketCover } from "./MarketCover";

export type Market = {
  id: string;
  slug: string;
  question: string;
  status: string;
  yes_price_cents: number;
  no_price_cents: number;
  volume_total_micro: string | number;
  liquidity_micro: string | number;
  trader_count: number;
  change_24h_bps: number;
  timeRemaining: string;
  category_name: string;
  category_color?: string;
  category_icon?: string;
  liquidity_label: string;
  event_slug?: string | null;
  event_title?: string | null;
  image_url?: string | null;
  image_fit?: "cover" | "contain" | "portrait" | null;
  spark?: number[];
};

export function MarketCard({ market }: { market: Market }) {
  const chg = Number(market.change_24h_bps || 0) / 100;
  return (
    <article className="card market-card">
      <Link to={`/markets/${market.slug}`} className="market-card-main">
        <MarketCover
          accent={market.category_color}
          eventSlug={market.event_slug}
          icon={market.category_icon}
          probability={market.yes_price_cents}
          imageUrl={market.image_url}
          fit={market.image_fit}
        />
        <div className="mkt-meta">
          <span className="badge badge-live">{market.status === "OPEN" ? "Live" : market.status}</span>
          <span>{market.event_title || market.category_name}</span>
        </div>
        <h3>{market.question}</h3>
        <div className="mkt-meta">
          <span className={chg >= 0 ? "up" : "down"}>{chg >= 0 ? "+" : ""}{chg.toFixed(1)}% 24h</span>
          <span>{formatUsd(market.volume_total_micro, true)} traded</span>
          <span>{market.timeRemaining}</span>
        </div>
      </Link>
      <div className="yesno">
        <Link className="pill-yes" to={`/markets/${market.slug}?buy=YES`}>
          <span>Yes {market.yes_price_cents}¢</span>
          <span>Buy</span>
        </Link>
        <Link className="pill-no" to={`/markets/${market.slug}?buy=NO`}>
          <span>No {market.no_price_cents}¢</span>
          <span>Buy</span>
        </Link>
      </div>
    </article>
  );
}

export type EventGroupCard = {
  slug: string;
  title: string;
  blurb: string;
  accent: string;
  marketCount: number;
  yesPriceCents: number;
  volumeMicro: string;
  image_url?: string | null;
  image_fit?: "cover" | "contain" | "portrait" | null;
};

export function EventCard({ group }: { group: EventGroupCard }) {
  return (
    <Link to={`/topics/${group.slug}`} className="card event-card">
      <MarketCover
        accent={group.accent}
        eventSlug={group.slug}
        probability={group.yesPriceCents}
        compact
        imageUrl={group.image_url}
        fit={group.image_fit}
      />
      <div>
        <strong>{group.title}</strong>
        <p>{group.blurb}</p>
        <span>{group.marketCount} contracts · {formatUsd(group.volumeMicro, true)}</span>
      </div>
    </Link>
  );
}
